<template>
    <v-dialog
      v-model="guide_dialog"
      fullscreen 
      persistent :overlay="false"
      transition="dialog-transition"
    >

    <template v-slot:activator="{ on }">
        <v-btn
          small
          color="success"
          dark
          v-on="on"
        >
          GUIDE D'UTILISATION
        </v-btn>
      </template>
    <v-card>
       <v-card-title primary-title class="font-weight-bold">
         Bienvenue dans le Swap HIROPAY
       </v-card-title>
       <v-card-text>
         Le SWAP HIROPAY vous permet d'acheter et vendre instantannément et sans aucun frais vos cryptomonnaies préferées sans passer par les ordres,
         ci dessous detaillée la procedure à suivre: <br><br>
        <div class="font-weight-bold " style="text-decoration: underline">
           A-COMMENT ACHETER LES CRYPOTOMONNAIES ET PERFECTMONEY <br>
        </div>

        <div class="ml-4">
          <p > pour acheter vos cryptomonnaies et perfectmoney sur HIROPAY, vous avez 2 options : <span class="font-weight-bold">PAIEMENT DIRECT et PAIEMENT AVEC SOLDE HIROPAY</span> </p>
            <div class="font-weight-bold ml-5 " style="text-decoration: underline;" >PAIEMENT DIRECT</div>
           <p ><span class="font-weight-bold">1 - </span>  Dans la partie DONNER Veuillez selectionner le moyen de paiement dans la section PAIEMENT DIRECT<br>
           <span class="font-weight-bold">2 - </span> Selectionner la monnaie à acheter dans la partie RECEVOIR <br>
           <span class="font-weight-bold">3 - </span> Saisir le montant a acheter et renseigner votre portefeuille de reception et cliquer sur <span class="font-weight-bold">Proceder à l'échange</span> <br>
           <span class="font-weight-bold">4 - </span> Sur la page qui s'affiche, renseigner le numero avec lequel vous desirez payer et cliquer sur le bouton <span class="font-weight-bold">PAYER</span><br>
           <span class="font-weight-bold">5- </span>Une notification de paiement sera envoyée a votre numero veuillez confirmer le paiement avec votre code secret<br>
           une fois le paiement effectué vous recevrez votre monnaie dans le portefeuille renseigné, aucune action supplémentaire n'est nécéssaire</p>
           <div class="font-weight-bold ml-5 " style="text-decoration: underline;" >PAIEMENT AVEC SOLDE HIROPAY</div>
           <p>Vous devez d'abord effectuer un dépôt de CFA sur la page la page solde en <v-btn flat href="/dashboard/funds" color="success">cliquant ici</v-btn> une fois votre dépôt effectué revenez sur la page SWAP et suivez ces etapes:<br> 
              <span class="font-weight-bold">1 - </span>Dans la partie DONNER Veuillez selectionner CFA la section SOLDE HIROPAY<br>
           <span class="font-weight-bold">2 - </span> Selectionner la monnaie à acheter dans la partie RECEVOIR <br>
           <span class="font-weight-bold">3 - </span> Saisir le montant a acheter et renseigner votre portefeuille de reception et cliquer sur <span class="font-weight-bold">Proceder à l'échange</span> <br>
           <span class="font-weight-bold">4 - </span> Sur la page qui s'affiche, saisir votre code PIN HIROPAY ou code 2FA et votre transaction sera traitée automatiquement<br>
            </p>
        </div>

        <div class="font-weight-bold " style="text-decoration: underline">
           B-COMMENT VENDRE LES CRYPOTOMONNAIES ET PERFECTMONEY <br>
        </div>
        <div class="ml-4">
            <p>
          <span class="font-weight-bold"> 1- pour vendre USDT et BNB et BTC directement sont faire de depot préalable</span> veuillez selectionner la devise a vendre dans la section DONNEZ ensuite renseigner votre numero mobile money, cliquer sur proceder a l'échange puis confirmer la transaction avec votre code pin ou code 2FA,
          une adresse vous sera alors générée, veuillez envoyer le montant a vendre sur l'adresse et attendez quelques instants pour recevoir votre CFA sur votre mobile money, aucune action supplémentaire n'est nécéssaire <br><br>

          <span class="font-weight-bold"> 2- pour vendre PM </span>  : <br> Dans la partie DONNER veuillez choisir PM dans la section PAIEMENT DIRECT pour vendre directement sans faire de dépôt <br> choisissez un moyen de paiement ainsi que votre numero mobile money,
          cliquez ensuite sur proceder à l'échange et sur la  page suivante assurez vous que les informations remplies sont correctes et cliquer sur le bouton PAYER, vous serez alors redirigés sur le site PERFECTMONEY
          pour effectuer votre paiement, une fois le paiement effectué vous recevrez votre CFA automatiquement sur votre mobile money, aucune action supplémentaire n'est nécéssaire 

          <br>
           
          <span>
            <span class="font-weight-bold"> 3- pour vendre BTC et PM disponible sur votre SOLDE HIROPAY</span> , vous devez pour le moment effecter un dépôt de BTC ou de PM au préalable en <v-btn flat href="/dashboard/funds" color="success">cliquant ici</v-btn> une fois votre dépôt effectué revenez sur la page SWAP
            et renseigner le montant a vendre, saisissez votre numero mobile money et valider la transaction avec votre code pin et vous recevez votre CFA sur votre mobile money, aucune action supplementaire n'est nécéssaire
          </span>
          </p>
        </div>

        

        <v-flex xs12 text-xs-center>
          <v-btn color="primary" @click="guide_dialog = false">FERMER LE GUIDE</v-btn>
        </v-flex>
       </v-card-text>
     </v-card>
      
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                guide_dialog:false
            }
        },
        
    }
</script>

<style lang="scss" scoped>

</style>